import React from 'react'
import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons'
import { Popover } from 'is24-corecss'
import styles from './LabelWithTooltip.module.css'

export interface LabelWithTooltipProps {
  inputId: string
  labelText: string
  tooltipContent: React.ReactNode
  showMandatory?: boolean
  placement?: 'top' | 'right' | 'bottom' | 'left' | 'top-start' | 'bottom-end' | 'bottom-start' | 'top-end'
  containerClassName?: string
  labelClassName?: string
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  inputId,
  labelText,
  tooltipContent,
  showMandatory = true,
  containerClassName = '',
  labelClassName = '',
  placement = 'bottom-start',
}) => {
  const labelContent = (
    <label
      htmlFor={inputId}
      id={`${inputId}-input-label`}
      className={`input-label ${showMandatory ? ' mandatory ' : ''} ${labelClassName} ${styles.labelHeight}`}
    >
      {labelText}
    </label>
  )

  return (
    <div className={`display-inline-flex ${containerClassName}`} style={{ alignItems: 'center' }}>
      {labelContent}
      <Popover.Root placement={placement}>
        <Popover.Target className='margin-left-s font-body-medium-regular align-left'>
          <IconS24InfoCircle24 style={{ color: 'var(--color-icon-weak)' }} width={20} height={20} />
        </Popover.Target>
        <Popover.Content className={styles.popOverContent}>{tooltipContent}</Popover.Content>
      </Popover.Root>
    </div>
  )
}

export default LabelWithTooltip
